export default __webpack_public_path__ + "static/media/pvilla5-3.8e211bb5.webp";